import React from 'react';
import AllRoutes from './routes/Routes';
function App() {
  return (
   <>
    <AllRoutes/>
   </>
  );
}

export default App;
